var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"excelIframe",staticClass:"iframe-class",style:({
        position: _vm.isHidden ? 'absolute' : 'relative',
        zIndex: _vm.isHidden ? -100 : ''
      }),attrs:{"src":_vm.sssDomain},on:{"load":_vm.handleIframe}})
}
var staticRenderFns = []

export { render, staticRenderFns }